import React, {useEffect} from "react";

import "./Styles.css";

const Alert = ({msg, visible, close}) => {

    useEffect(() => {
        let app = document.getElementsByTagName('body').item(0)
        if(visible){
            window.scrollTo({ top: 0, behavior: 'smooth' });
            app.classList.add("hiddenApp")
        }else{
            app.classList.remove('hiddenApp')
        }
    }, [visible])

    return (
        <React.Fragment>
            { !visible ? null :
                <div className="containerAlert" id="alert">
                    <div className="areaAlert">
                        <div className="closeAlert" onClick={close}></div>
                        <span className="msg-alert">{msg}</span>
                        <div className="container-button-close">
                            <button onClick={close} className="close-alert">Fechar</button>
                        </div>
                    </div>
                </div>
            }
        </React.Fragment>
    )
}

export default Alert